import { useMemo, useSyncExternalStore } from "react";
import {
  getVoiceNoteProgress,
  getVoiceNoteProgressRevision,
  getVoiceNoteProgressSessionIds,
  subscribeToVoiceNoteProgress,
  type VoiceNoteProgressPhase,
} from "@/lib/voice-note-progress";

function useVoiceNoteProgressRevision(): number {
  return useSyncExternalStore(
    subscribeToVoiceNoteProgress,
    getVoiceNoteProgressRevision,
    getVoiceNoteProgressRevision,
  );
}

/** Observe voice-note preparation work for one session. */
export function useVoiceNoteProgress(sessionId: string): VoiceNoteProgressPhase | null {
  const revision = useVoiceNoteProgressRevision();
  return useMemo(() => getVoiceNoteProgress(sessionId), [sessionId, revision]);
}

/** Observe every session with voice-note preparation work in progress. */
export function useVoiceNoteProgressSessionIds(): ReadonlySet<string> {
  const revision = useVoiceNoteProgressRevision();
  return useMemo(() => getVoiceNoteProgressSessionIds(), [revision]);
}
